import { render } from "./LeadsList.vue?vue&type=template&id=259efd7c&scoped=true"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"

import "./LeadsList.vue?vue&type=style&index=0&id=259efd7c&lang=scss&scoped=true"
import "./LeadsList.vue?vue&type=style&index=1&id=259efd7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259efd7c"]])

export default __exports__